import amazonLogoSvg from '@listening/assets/astro/images/amazon-logo.svg';
import eBayLogoSvg from '@listening/assets/astro/images/eBay-logo.svg';
import groupSvg from '@listening/assets/astro/images/Group.svg';
import group1Png from '@listening/assets/astro/images/Group_1.png';
import group1Png_ from '@listening/assets/astro/images/Group-1.png';
import group2Png from '@listening/assets/astro/images/Group-2.png';

export function PricingComparisonSection() {
  return (
    <section className='flex flex-col items-center justify-center px-5 py-18 sm:px-14 lg:px-18'>
      <div className='w-full max-w-[1296px]'>
        <div className='flex flex-col items-center gap-6 pb-6' id='notes'>
          <div className='flex flex-col items-center justify-start gap-6 pb-6'>
            <div className='flex items-center justify-center gap-3 rounded-full bg-azure-455/10 px-4 py-[5px]'>
              <div className='rotate-90 text-[20px] leading-[27px] font-[500]'>
                👆
              </div>
              <div className='text-[12px] leading-[16px] font-[600] text-neutral-945 sm:text-[16px] sm:leading-[21.6px]'>
                MADE FOR YOU
              </div>
            </div>

            <h2 className='text-center text-[28px] leading-[30px] font-[700] text-neutral-945 sm:text-[40px] sm:leading-[43px] lg:text-[48px] lg:leading-[64px]'>
              This{' '}
              <span className='text-azure-595'>
                transformational
                <br />
                tool
              </span>{' '}
              is more affordable than ...
            </h2>
          </div>
          <div className='flex w-full flex-col items-center justify-around gap-8 lg:flex-row lg:gap-18'>
            <div className='relative'>
              <img
                alt='Amazon notebook'
                className='max-w-full sm:max-w-[542px]'
                loading='eager'
                src={group1Png}
              />
              <div className='absolute inset-0 hidden flex-col items-end justify-start gap-8 pt-[100px] pr-[77px] pl-0'>
                <div className='flex items-center justify-center rounded-full bg-white bg-[linear-gradient(rgba(255,_172,_53,_.12),_rgba(255,_172,_53,_.12))] p-[21px] [box-shadow:0_5.7px_48.8px_rgba(193,_216,_251,_.1)]'>
                  <img
                    alt='Amazon'
                    className='size-[35px] h-[61px] w-[66px] sm:size-8 lg:size-auto'
                    loading='lazy'
                    src={amazonLogoSvg}
                  />
                </div>
              </div>
            </div>
            <div className='flex flex-col items-center gap-4 sm:items-start'>
              <div className='text-[24px] leading-[25px] font-[400] text-neutral-945 sm:text-[36px] sm:leading-[38px]'>
                A <span className='font-[700]'>new</span> text book
              </div>
              <div className='text-[24px] leading-[25px] text-scarlet-500 sm:text-[36px] sm:leading-[38px]'>
                $150
              </div>
            </div>
          </div>
          <div className='flex w-full flex-col-reverse items-center justify-around gap-8 lg:flex-row lg:gap-18'>
            <div className='flex flex-col items-center gap-4 sm:items-start'>
              <div className='text-[24px] leading-[25px] font-[400] text-neutral-945 sm:text-[36px] sm:leading-[38px]'>
                A <span className='font-[700]'>used</span> text book
              </div>
              <div className='text-[24px] leading-[25px] text-scarlet-500 sm:text-[36px] sm:leading-[38px]'>
                $55
              </div>
            </div>
            <div className='relative'>
              <img
                alt='Ebay notebook'
                className='max-w-full sm:max-w-[542px]'
                loading='eager'
                src={group1Png_}
              />
              <div className='absolute inset-0 hidden items-start justify-end pt-[43.5px] pr-[47px]'>
                <div className='flex items-center justify-center rounded-[999px] bg-white bg-[linear-gradient(to_right,_rgba(229,_50,_56,_.1),_rgba(0,_100,_210,_.1)_36%,_rgba(135,_182,_234,_.58)_66%,_rgba(134,_184,_23,_.1))] px-[40px] py-[12px] [box-shadow:0_5.7px_48.8px_rgba(193,_216,_251,_.1)]'>
                  <img
                    alt='Ebay'
                    className='h-[30px] w-[75px] lg:h-[61px] lg:w-[98px]'
                    loading='lazy'
                    src={eBayLogoSvg}
                  />
                </div>
                <div className='hidden min-w-[160px] flex-col gap-[8px] rounded-[8px] bg-white p-[12px] [box-shadow:0_5.5px_46px_rgba(193,_216,_251,_.5)]'>
                  <div className='text-[20px] leading-[27px] font-[500] text-neutral-945'>
                    A <span className='font-[700]'>used</span> text book
                  </div>
                  <div className='text-[18px] leading-[24px] font-[600] text-neutral-700'>
                    $55
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='flex w-full flex-col items-center justify-around gap-8 lg:flex-row lg:gap-18'>
            <div className='relative'>
              <img
                alt='Phone'
                className='max-h-[501px]'
                loading='eager'
                src={group2Png}
              />
            </div>
            <div className='flex flex-col items-center gap-4 sm:items-start'>
              <div className='text-[24px] leading-[25px] font-[400] text-neutral-945 sm:text-[36px] sm:leading-[38px]'>
                A <span className='font-[700]'>cell phone</span> plan
              </div>
              <div className='text-[24px] leading-[25px] text-scarlet-500 sm:text-[36px] sm:leading-[38px]'>
                $40/mo
              </div>
            </div>
          </div>
          <div className='flex w-full flex-col-reverse items-center justify-around gap-8 lg:flex-row lg:gap-18'>
            <div className='flex flex-col items-center gap-4 sm:items-start'>
              <div className='text-[24px] leading-[25px] font-[400] text-neutral-945 sm:text-[36px] sm:leading-[38px]'>
                A <span className='font-[700]'>Netflix</span> subscription
              </div>
              <div className='text-[24px] leading-[25px] text-scarlet-500 sm:text-[36px] sm:leading-[38px]'>
                $15/mo
              </div>
            </div>
            <div className='flex size-[205px] items-center justify-center rounded-full bg-scarlet-800/5 sm:size-[278px]'>
              <div className='flex size-[154px] items-center justify-center rounded-full bg-scarlet-800/15 sm:size-[209px]'>
                <div className='flex size-[97px] items-center justify-center rounded-full bg-white bg-[linear-gradient(rgba(229,_9,_20,_.3),_rgba(229,_9,_20,_.3))] sm:size-[132px]'>
                  <img
                    alt='Netflix'
                    className='size-[35px] h-[61px] w-[66px] sm:size-8 lg:size-auto'
                    loading='eager'
                    src={groupSvg}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
